(() => {
  if (window.kloveFabricsReady) return;
  window.kloveFabricsReady = true;
  let trigger;
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-fabric-filter]');
    if (filter) {
      const root = filter.closest('[data-fabric-library]');
      root.querySelectorAll('[data-fabric-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      root.querySelectorAll('[data-fabric-group]').forEach(group => { group.hidden = !!filter.dataset.fabricFilter && group.dataset.fabricGroup !== filter.dataset.fabricFilter; });
    }
    const dialog = document.querySelector('[data-fabric-dialog]');
    if (!dialog) return;
    const opener = event.target.closest('[data-fabric-preview]');
    if (opener) {
      event.preventDefault();
      const source = opener.dataset.fabricImage;
      if (!source) return;
      trigger = opener;
      const image = dialog.querySelector('[data-fabric-image]');
      image.src = source;
      image.alt = opener.dataset.fabricTitle || '';
      dialog.querySelector('[data-fabric-title]').textContent = opener.dataset.fabricTitle || '';
      dialog.querySelector('[data-fabric-collection]').textContent = opener.dataset.fabricCollection || '';
      dialog.querySelector('[data-fabric-description]').textContent = opener.dataset.fabricDescription || '';
      dialog.showModal();
    } else if (event.target.closest('[data-fabric-close]') || event.target === dialog) dialog.close();
  });
  const dialog = document.querySelector('[data-fabric-dialog]');
  dialog?.addEventListener('close', () => { if (trigger?.isConnected) trigger.focus(); });
})();
